<div class="space-y-4">
    <div>
        <h3 class="text-lg font-semibold text-gray-900 dark:text-gray-100">Acordos mensais</h3>
        <p class="text-xs text-gray-500">
            Envie os acordos, gere um link público (sem login) para um ou vários arquivos e acompanhe a assinatura.
        </p>
    </div>

    <div class="flex items-center justify-center gap-3 flex-wrap">
        <button mat-stroked-button color="primary" type="button" (click)="fileInput.click()" class="h-14 flex items-center">
            <mat-icon [svgIcon]="'heroicons_outline:arrow-up-tray'"></mat-icon>
            Selecionar Arquivo
        </button>
        <input #fileInput type="file" multiple class="hidden" (change)="onSelectFiles($event)" />
        <button
            *ngIf="hasChanges"
            mat-flat-button
            color="primary"
            type="button"
            (click)="save()"
            [disabled]="saving"
            class="h-14 flex items-center"
        >
            <mat-icon [svgIcon]="'heroicons_outline:check'"></mat-icon>
            Salvar
        </button>
    </div>

    <div *ngIf="!loading && pendingUnsignedItems.length > 0" class="flex flex-wrap items-center gap-2 justify-between p-3 rounded border border-blue-100 bg-blue-50/60 dark:bg-transparent dark:border-gray-700">
        <div class="flex items-center gap-2">
            <mat-checkbox
                [checked]="allPendingSelected"
                (change)="toggleSelectAllPending($event.checked)"
                color="primary"
            >
                Selecionar pendentes
            </mat-checkbox>
            <span class="text-xs text-gray-500" *ngIf="selectedPendingCount">
                {{ selectedPendingCount }} selecionado(s)
            </span>
        </div>
        <div class="flex flex-wrap items-center gap-2">
            <button
                mat-stroked-button
                type="button"
                color="primary"
                [disabled]="batchLoading"
                (click)="copyLinkBatch()"
                matTooltip="Gera um único link público para os selecionados (ou todos pendentes)"
            >
                <mat-icon [svgIcon]="'heroicons_outline:link'"></mat-icon>
                Gerar link do pacote
            </button>
            <button
                mat-flat-button
                type="button"
                color="primary"
                [disabled]="batchLoading"
                (click)="sendEmailBatch()"
                matTooltip="Envia um e-mail com um único link para os selecionados (ou todos pendentes)"
            >
                <mat-icon [svgIcon]="'heroicons_outline:envelope'"></mat-icon>
                Enviar e-mail do pacote
            </button>
        </div>
    </div>

    <div *ngIf="loading" class="flex justify-center py-6">
        <mat-spinner diameter="36"></mat-spinner>
    </div>

    <div *ngIf="!loading && pendingFiles.length > 0" class="space-y-2">
        <div
            *ngFor="let file of pendingFiles; let i = index"
            class="flex items-center justify-between p-3 rounded border border-dashed border-gray-300 bg-gray-50 dark:bg-transparent dark:border-gray-600"
        >
            <div class="flex items-center gap-3 min-w-0">
                <mat-icon [svgIcon]="'heroicons_outline:clock'" class="text-amber-600"></mat-icon>
                <div class="min-w-0">
                    <div class="font-medium truncate">{{ file.name }}</div>
                    <div class="text-xs text-amber-700">Não enviado</div>
                </div>
            </div>
            <button mat-icon-button color="warn" type="button" (click)="removePending(i)" matTooltip="Remover">
                <mat-icon [svgIcon]="'heroicons_outline:trash'"></mat-icon>
            </button>
        </div>
    </div>

    <div *ngIf="!loading && items.length === 0 && pendingFiles.length === 0" class="text-center py-10 text-gray-500 text-sm">
        Nenhum acordo enviado ainda.
    </div>

    <div *ngIf="!loading && items.length > 0" class="space-y-2">
        <div
            *ngFor="let item of items"
            class="flex flex-col sm:flex-row sm:items-center justify-between gap-3 p-3 rounded border border-gray-200 dark:border-gray-700 bg-white dark:bg-transparent"
        >
            <div class="min-w-0 flex-1 flex items-start gap-2">
                <mat-checkbox
                    *ngIf="item.signature?.status !== 'signed'"
                    class="mt-0.5"
                    [checked]="isSelected(item)"
                    (change)="toggleSelect(item, $event.checked)"
                    color="primary"
                ></mat-checkbox>
                <div class="min-w-0 flex-1">
                    <div class="font-medium truncate">{{ getFileName(item) }}</div>
                    <div class="flex flex-wrap items-center gap-2 mt-1">
                        <span class="text-xs px-2 py-0.5 rounded" [ngClass]="statusClass(item)">{{ statusLabel(item) }}</span>
                        <span *ngIf="item.file_module?.createdAt" class="text-xs text-gray-500">
                            {{ item.file_module.createdAt | date : 'dd/MM/yy HH:mm' }}
                        </span>
                        <span *ngIf="item.signature?.signed_at" class="text-xs text-gray-500">
                            Assinado em {{ item.signature.signed_at | date : 'dd/MM/yy HH:mm' }}
                        </span>
                        <span *ngIf="item.signature?.status === 'pending' && item.signature?.expires_at" class="text-xs text-gray-500">
                            Expira em {{ item.signature.expires_at | date : 'dd/MM/yy' }}
                        </span>
                    </div>
                </div>
            </div>

            <div class="flex flex-wrap items-center gap-1">
                <button mat-icon-button type="button" matTooltip="Abrir" (click)="openFile(item)">
                    <mat-icon [svgIcon]="'heroicons_outline:eye'"></mat-icon>
                </button>
                <button mat-icon-button type="button" matTooltip="Baixar original" (click)="downloadOriginal(item)">
                    <mat-icon [svgIcon]="'heroicons_outline:arrow-down-tray'"></mat-icon>
                </button>
                <button
                    mat-icon-button
                    type="button"
                    matTooltip="Gerar / copiar link (só este arquivo)"
                    [disabled]="actionLoadingId === item.file_module.file_module_id || item.signature?.status === 'signed'"
                    (click)="copyLink(item)"
                >
                    <mat-icon [svgIcon]="'heroicons_outline:link'"></mat-icon>
                </button>
                <button
                    mat-icon-button
                    type="button"
                    matTooltip="Enviar e-mail (só este arquivo)"
                    [disabled]="actionLoadingId === item.file_module.file_module_id || item.signature?.status === 'signed'"
                    (click)="sendEmail(item)"
                >
                    <mat-icon [svgIcon]="'heroicons_outline:envelope'"></mat-icon>
                </button>
                <button
                    *ngIf="item.signature?.signed_pdf_path"
                    mat-icon-button
                    type="button"
                    matTooltip="Baixar assinado"
                    (click)="downloadSigned(item)"
                >
                    <mat-icon [svgIcon]="'heroicons_outline:document-check'"></mat-icon>
                </button>
                <button mat-icon-button color="warn" type="button" matTooltip="Remover" (click)="removeItem(item)">
                    <mat-icon [svgIcon]="'heroicons_outline:trash'"></mat-icon>
                </button>
            </div>
        </div>
    </div>
</div>
